// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => { }

export function getPosition(value, unit) {
  const { w, h, row, col } = value
  const arr = [w, h, col - 1, row - 1].map(value => value * unit + "px")
  return {
    width: arr[0],
    height: arr[1],
    left: arr[2],
    top: arr[3]
  }
}

const getGrids = (items, isPl = false, exclude) => {
  const grids = new Set()
  let row, col, w, h
  items.forEach(item => {
    if (item === exclude) return
    const p = isPl ? item : JSON.parse(item.cardLocal)
    row = p.row
    col = p.col
    w = p.w
    h = p.h

    const start = (row - 1) * 12 + col
    for (let i = 0; i < w; i++) {
      for (let j = 0; j < h; j++) {
        grids.add(start + i + 12 * j)
      }
    }
  })
  return grids
}

export default class Drag {
  x = 0
  y = 0
  maxX = 0
  unit = 0
  placeholder = {}
  items = []
  grids = new Set()
  rect = {}
  canDrop = true

  register(card, rect, items, exclude) {
    const { width } = rect
    this.items = items
    this.grids = getGrids(items, false, exclude)
    this.x = 0
    this.y = 0
    this.placeholder.w = card.w || 4
    this.placeholder.h = card.h || 4
    this.unit = width / 12
    //todo
    this.maxX = width - (card.w || 4) * this.unit + this.unit
    // this.maxX = width - 4 * this.unit + this.unit
    this.rect = rect
    this.canDrop = true
  }

  unRegister(cb) {
    this.placeholder = {}
    if (cb) {
      cb({
        display: "none"
      })
    }
  }

  onDrop(cb) {
    if (!this.canDrop) return
    if (cb) cb(this.placeholder)
  }

  onMove(e, cb = noop) {
    const x = Math.abs(e.clientX - this.rect.x);
    const y = Math.abs(e.clientY - this.rect.y);
    this.x = x
    this.y = y
    const bool = this.setPlaceholder()

    if (this.hasItem() || x >= this.maxX) {
      this.canDrop = false
      cb({
        display: "none"
      })
    }
    else if (bool) {
      this.canDrop = true
      cb(getPosition(this.placeholder, this.unit))
    }
  }

  hasItem() {
    const pl = getGrids([this.placeholder], true)
    let bool = false
    pl.forEach(v => {
      if (this.grids.has(v)) bool = true
    })
    return bool
  }

  setPlaceholder() {
    const prevRow = this.placeholder.row
    const prevCol = this.placeholder.col
    const col = Math.ceil(this.x / this.unit)
    const row = Math.ceil(this.y / this.unit)
    this.placeholder.row = row
    this.placeholder.col = col
    return prevRow !== row || prevCol !== col
  }
}
